export default __webpack_public_path__ + "static/media/logo.7bb8bd99.png";